import { CONCESSION_FOOD_AND_DRINK_VENUE_IDS } from '../constants'
import { GENERIC_CONCESSION_VALIDATION_ERROR } from './concessionValidationConstants'

const stripHtml = value =>
  String(value ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()

export const resolveVenueTicketmasterId = (venueId, venues = []) => {
  const venue = venues.find(item => String(item._id) === String(venueId))
  return venue?.id || ''
}

export const isFoodAndDrinkSectionVenue = (venueId, venues = []) => {
  const ticketmasterId = resolveVenueTicketmasterId(venueId, venues)
  return CONCESSION_FOOD_AND_DRINK_VENUE_IDS.includes(ticketmasterId)
}

export const getDefaultFoodAndDrink = () => ({
  enabled: false,
  venue_scope: 'theatres_only',
  title: '',
  html_description: ''
})

export const getConcessionFoodAndDrinkFieldErrors = (foodAndDrink = {}, { venueId, venues = [] } = {}) => {
  if (!isFoodAndDrinkSectionVenue(venueId, venues)) {
    return { title: '', description: '' }
  }

  if (foodAndDrink.enabled === false) {
    return { title: '', description: '' }
  }

  const title = String(foodAndDrink.title ?? '').trim()
  const description = stripHtml(foodAndDrink.html_description)

  return {
    title: !title ? 'Section header is required' : '',
    description: !description ? 'Description is required' : ''
  }
}

export const validateConcessionFoodAndDrink = (foodAndDrink = {}, options = {}) => {
  const fieldErrors = getConcessionFoodAndDrinkFieldErrors(foodAndDrink, options)

  if (fieldErrors.title || fieldErrors.description) {
    return {
      isValid: false,
      message: GENERIC_CONCESSION_VALIDATION_ERROR
    }
  }

  return { isValid: true, fieldErrors }
}
